import { useState } from "react";

import { Column, MEDIA, MediaStack, ToggleSpacedButtons, useTimeWindow } from "@bridgesplit/ui";
import { isLeverageLoop } from "@bridgesplit/abf-react";

import { useLoopContext } from "../LoopContext";
import { LoopApyHistory, LoopPerformanceHistory, LoopPrincipalDepositHistory } from "./charts";
import { OpenChart } from "./charts/chartOptions";

export default function LoopDetailCharts() {
    const { loopExpanded } = useLoopContext();
    const { period, setPeriod, xDomain } = useTimeWindow({ storageKey: "LoopDetailChartsPeriod" });

    const isLeverage = isLeverageLoop(loopExpanded);
    const chartOptions = getChartOptions(isLeverage);

    const [openChart, setOpenChart] = useState<OpenChart>(isLeverage ? OpenChart.Performance : OpenChart.Apy);

    return (
        <Column spacing={2}>
            <MediaStack query={MEDIA.SM} spacing={2} spaceBetweenRow sxAbove={{ alignItems: "flex-start" }}>
                <ToggleSpacedButtons size="small" value={openChart} setValue={setOpenChart} options={chartOptions} />
            </MediaStack>
            {openChart === OpenChart.Apy && <LoopApyHistory period={period} xDomain={xDomain} />}
            {isLeverage && openChart === OpenChart.Performance && (
                <LoopPerformanceHistory period={period} setPeriod={setPeriod} xDomain={xDomain} />
            )}
            {(openChart === OpenChart.Deposits || openChart === OpenChart.Borrows) && (
                <LoopPrincipalDepositHistory
                    period={period}
                    setPeriod={setPeriod}
                    xDomain={xDomain}
                    openChart={openChart}
                />
            )}
        </Column>
    );
}

function getChartOptions(isLeverage: boolean) {
    return isLeverage
        ? [
              { value: OpenChart.Performance },
              { value: OpenChart.Apy },
              { value: OpenChart.Deposits },
              { value: OpenChart.Borrows }
          ]
        : [{ value: OpenChart.Apy }, { value: OpenChart.Deposits }, { value: OpenChart.Borrows }];
}
